import { createSlice } from "@reduxjs/toolkit";
import {
  InitialState,
  Reducers,
  TRANSACTION,
} from "../../constants/transaction";
import { RootState } from "../";

const initialState: InitialState = {
  transactions: [],
  isFetching: false,
  income: 0,
  expense: 0,
  transfer: 0,
};

const reducers: Reducers = {
  setTransactions: (state, action) => {
    state.transactions = action.payload;
  },
  setTotals: (state, action) => {
    state.income = action.payload.income;
    state.expense = action.payload.expense;
    state.transfer = action.payload.transfer;
  },
  setIsFetching: (state, action) => {
    state.isFetching = action.payload;
  },
  addTransaction: (state, action) => {
    state.transactions = [action.payload, ...state.transactions];
  },
};

const transactionSlice = createSlice({
  name: TRANSACTION,
  initialState,
  reducers,
});

export const transactionState = (state: RootState) => state.transaction;
export const { setTransactions, setTotals, setIsFetching, addTransaction } =
  transactionSlice.actions;
export default transactionSlice;
